export const ml = {
    "TRIGGER_LISTEN": "ട്രിഗറുകൾക്കായി കേൾക്കുന്നു,",
    "ASSIST_EMPTY_MSG": "ഏജന്റ് എഐ നിങ്ങളുടെ സംഭാഷണം സജീവമായി കേൾക്കുകയും ട്രിഗർ ചെയ്താൽ സ്വയം സഹായിക്കാൻ സജ്ജമാണും,",
    "MYBOT_TRIGGET_LISTEN": "ഇപ്പോൾ സജീവമായ എന്റെ ബോട്ട് ടാസ്കുകൾ ഒന്നുമില്ല,",
    "MYBOT_EMTPY_MSG": "എന്റെ ബോട്ടിൽ ഒരു ടാസ്ക് ആരംഭിക്കുന്നതിന്, തിരയൽ ടാബിലേക്കു പോകുക കൂടാതെ നിങ്ങൾ ആഗ്രഹിക്കുന്ന ടാസ്കിനായി \"\"ഏജന്റ് ഇൻപുട്ടുകളോടെ പ്രവർത്തിക്കുക\"\" ഓപ്ഷൻ തിരഞ്ഞെടുക്കുക,",
    "PROACTIVE_MODE": "പ്രോആക്റ്റീവ് മോഡ്,",
    "SETTINGS": "സെറ്റിംഗ്സ്,",
    "HELP_AND_SUPPORT": "സഹായവും പിന്തുണയും,",
    "HELP": "സഹായം,",
    "LANGUAGE": "ഭാഷ,",
    "THEME": "തീം,",
    "AUTOMATIC": "സ്വയം,",
    "DARK": "ഇരുണ്ട,",
    "FILE_NAME":"ഫയലിന്റെ പേര്",
    "AUTO_SCROLL_TOOLTIP":"സഹായ ടാബ്, എന്റെ ബോട്ട് & ട്രാൻസ്ക്രിപ്റ്റ് ടാബ് ഉള്ളടക്കത്തിന്റെ ഓട്ടോ സ്ക്രോളിംഗ് നിയന്ത്രിക്കുന്നു",
    "LIGHT": "വെളുത്ത,",
    "THEME_DESC": "ഇത് നിങ്ങളുടെ സിസ്റ്റം ഡീഫാൾട്ട് മോഡ് ഉപയോഗിക്കും,",
    "DOCUMENTATION": "ഡോക്യുമെന്റേഷൻ,",
    "DOC_DESC": "ഞങ്ങളുടെ സവിശദമായ ഡോക്യുമെന്റേഷൻ ലേഖനങ്ങൾ പരിശോധിക്കുക,",
    "FAQ_U": "പതിവ് ചോദിക്കുന്ന ചോദ്യങ്ങൾ,",
    "FAQ_DESC": "ഏജന്റ് എഐയുമായി ബന്ധപ്പെട്ട് പതിവ് ചോദിക്കുന്ന ചോദ്യങ്ങൾ പരിശോധിക്കുക,",
    "KORE_ACADEMY": "കോർ അക്കാദമി,",
    "KORE_ACA_DESC": "അക്കാദമി കോഴ്‌സുകൾ വഴി ഏജന്റ് എഐയെ കുറിച്ച് കൂടുതൽ അറിയുക,",
    "SEARCH": "തിരയുക,",
    "MY_BOT": "എന്റെ ബോട്ട്,",
    "TAB_TEXT":"ടാബ് ഒന്നും പ്രവർത്തനക്ഷമമല്ല! ദയവായി കുറഞ്ഞത് ഒരു ടാബ് പ്രവർത്തനക്ഷമമാക്കുക",
    "ASSIST": "സഹായം,",
    "TRANSCRIPT": "ട്രാൻസ്ക്രിപ്റ്റ്,",
    "HISTORY": "ചരിത്രം,",
    "STARTOVER": "പുതുതായി തുടങ്ങുക,",
    "RESTART_INPUTS": "പിടിച്ചെടുത്ത ഇൻപുട്ടുകളോടുകൂടി പുനരാരംഭിക്കുക,",
    "ASKCUSTOMER": "കസ്റ്റമറെ ചോദിക്കുക,",
    "TELLCUSTOMER": "കസ്റ്റമറെ അറിയിക്കുക,",
    "TAP_SEARCH":"തിരയാൻ ടാപ്പ് ചെയ്യുക",
    "WELCOME_MSG": "സ്വാഗത സന്ദേശം,",
    "SEND": "അയക്കുക,",
    "SENT": "അയച്ചു,",
    "AWAITING": "മറുപടി കാത്തിരിക്കുന്നു | തുടരാൻ ടൈപ്പ് ചെയ്യുക,",
    "OVERRIDE": "തുടരാൻ ടൈപ്പ് ചെയ്യുക,",
    "OVERRIDE_FILE": "തുടരാൻ ഫയൽ സംയോജിപ്പിക്കുക,",
    "ACCEPT_RESPONSE": "മറുപടി സ്വീകരിച്ചു,",
    "AGENT_ENTERED": "ഏജന്റ് പ്രവേശിച്ചു,",
    "EXPECTED_FORMAT": "പ്രതീക്ഷിക്കുന്ന ഫോർമാറ്റ്,",
    "INPUT_VALUES": "ഇൻപുട്ട് മൂല്യങ്ങൾ,",
    "RESTART": "പുനരാരംഭിക്കുക,",
    "START_OVER": "പുതുതായി തുടങ്ങുക,",
    "RESTART_CAPTURE": "പിടിച്ചെടുത്ത ഇൻപുട്ടുകളോടുകൂടി പുനരാരംഭിക്കുക,",
    "CANCEL": "റദ്ദാക്കുക,",
    "INTERRUPT_DIALOG": "വിലക്കപ്പെട്ട സംഭാഷണ ടാസ്ക്,",
    "RUN": "റൺ,",
    "RUN_AGENT": "ഏജന്റിന്റെ ഇൻപുട്ടോടുകൂടി റൺ,",
    "STEP": "നടപ്പ്,",
    "DIALOG_TASK": "സംഭാഷണ ടാസ്ക്,",
    "FAQ": "പതിവ് ചോദിക്കുന്ന ചോദ്യങ്ങൾ,",
    "SNIPPET": "ഉത്തരങ്ങൾ,",
    "ARTICLE": "വെബ്ബ് പേജുകൾ,",
    "FILE": "ഫയലുകൾ,",
    "SUGGESTED": "സൂചിപ്പിച്ച,",
    "ALL_DIALOG": "എല്ലാ സംഭാഷണ ടാസ്കുകളും,",
    "DIALOG_TEXT": "സംഭാഷണം,",
    "INTENT_IDENTIFIED": "കസ്റ്റമറുടെ ഉച്ചാരണ,",
    "NOT_WHAT_LOOKING": "തെറ്റായ നിർദ്ദേശം?",
    "BOT": "ബോട്ട്,",
    "CUSTOMER": "കസ്റ്റമർ,",
    "YOU": "നിങ്ങൾ,",
    "TERMINATE_CONV": "സംഭാഷണ ടാസ്ക് അവസാനിപ്പിക്കുക,",
    "TERMINATE_CONV_DESC": "സംഭാഷണ ടാസ്ക് അവസാനിപ്പിക്കണമെന്നതിന് നിങ്ങൾ ഉറപ്പാണോ? ഏജന്റ് എഐക്കു ഇനി നിർദേശങ്ങൾ നൽകാൻ കഴിയില്ല,",
    "YES_TERMINATE": "അതെ, അവസാനിപ്പിക്കുക,",
    "NO_CANCEL": "ഇല്ല, റദ്ദാക്കുക,",
    "OVERRIDE_CONTINUE": "ഓവർറൈഡ് മോഡിൽ തുടരുക,",
    "SUMMARY_TEXT": "സാരാംശം,",
    "SUBMIT": "സമർപ്പിക്കുക,",
    "INTERRUPT_OCCURED": "വിലക്ക് സംഭവിച്ചു,",
    "IDENTIFIED_INTENT": "തിരിച്ചറിയപ്പെട്ട ഉദ്ദേശം,",
    "INTERRUPT_DESC": "ഇത് പ്രവർത്തിപ്പിക്കുന്നത് നിങ്ങളുടെ ഇപ്പോഴുള്ള സംഭാഷണ ടാസ്ക് അവസാനിപ്പിക്കും,",
    "ACCEPT_RUN": "സ്വീകരിക്കുക കൂടാതെ റൺ ചെയ്യുക,",
    "RUN_LATER": "ശേഷം റൺ ചെയ്യുക,",
    "KNOW_MORE": "കൂടുതൽ അറിയുക,",
    "MORE_TEXT": "കൂടുതൽ,",
    "LESS_TEXT": "കുറവ്,",
    "VIEW_MORE": "കൂടുതൽ കാണുക,",
    "VIEW_LESS": "കുറച്ച് കാണുക,",
    "SHOW_MORE_FAQ": "കൂടുതൽ പതിവ് ചോദിക്കുന്ന ചോദ്യങ്ങൾ കാണിക്കുക,",
    "SHOW_LESS_FAQ": "കുറച്ചെണ്ണം പതിവ് ചോദിക്കുന്ന ചോദ്യങ്ങൾ കാണിക്കുക,",
    "SHOW_MORE_ARTICLE": "കൂടുതൽ വെബ് പേജുകൾ കാണിക്കുക,",
    "SHOW_LESS_ARTICLE": "കുറച്ചെണ്ണം വെബ് പേജുകൾ കാണിക്കുക,",
    "SHOW_MORE_SNIPPET": "കൂടുതൽ ഉത്തരങ്ങൾ കാണിക്കുക,",
    "SHOW_LESS_SNIPPET": "കുറച്ച് ഉത്തരങ്ങൾ കാണിക്കുക,",
    "SHOW_MORE_FILES": "കൂടുതൽ ഫയലുകൾ കാണിക്കുക,",
    "SHOW_LESS_FILES": "കുറച്ചെണ്ണം ഫയലുകൾ കാണിക്കുക,",
    "VIEW_ALL_DIALOG": "എല്ലാ സംഭാഷണങ്ങളും കാണുക,",
    "VIEW_FEW_DIALOG": "ചുരുക്കം സംഭാഷണങ്ങൾ കാണുക,",
    "HELP_FULL": "ഉപകാരപ്രദമാണോ?",
    "THANKYOU": "നന്ദി!",
    "EXPAND_MORE": "വിപുലീകരിക്കുക / കൂടുതൽ,",
    "CLOSE_TEXT": "അടയ്ക്കുക,",
    "STARTED": "തുടങ്ങിയിരിക്കുന്നു,",
    "ENDED": "അവസാനിച്ചു,",
    "VIEW_FULL_ARTICLE": "വെബ് പേജ് കാണുക,",
    "VIEW_FULL_FILE": "ഫയൽ കാണുക,",
    "COPIED": "പകർന്നു,",
    "SENTI_ANALY": "സെന്റിമെന്റ് വിശകലനം,",
    "WRONG_SUGGESTION": "തെറ്റായ നിർദേശങ്ങൾ,",
    "INCORRECT_INTENT": "തെറ്റായ ഉദ്ദേശം,",
    "ACCIDENTAL_CLICK": "തെറ്റിദ്ധരിച്ച ക്ലിക്ക്,",
    "TIME_TAKING": "സമയം എടുക്കുന്നു,",
    "OTHER": "മറ്റുള്ളവ,",
    "PLAYBOOK_EMPTY_MSG": "പ്ലേബുക്ക് തിരഞ്ഞെടുക്കുക,",
    "PLAYBOOK_EMPTY_DESC": "എല്ലാ ലഭ്യമായ പ്ലേബുക്കുകളും ഡൈനാമിക് ആയതിനാൽ ഏജന്റ് എഐക്ക് പ്ലേബുക്ക് ലോഡ് ചെയ്യാൻ കഴിയുന്നില്ല. പ്ലേബുക്ക്‌ ആക്‌സസ് ചെയ്യാൻ 'പ്ലേബുക്ക് തിരഞ്ഞെടുക്കുക' ക്ലിക്ക് ചെയ്യുക,",
    "STAGE": "ഘട്ടം,",
    "PROCEED_TO_CLOSE": "അടയ്ക്കാൻ തുടരുക,",
    "RECOMENDED_PLAYBOOK": "ശുപാർശ ചെയ്ത പ്ലേബുക്ക്,",
    "PRIMARY_SCRIPTS": "പ്രാഥമിക സ്ക്രിപ്റ്റുകൾ,",
    "DYNAMIC_SCRIPTS": "ഡൈനാമിക് സ്ക്രിപ്റ്റുകൾ,",
    "RESUME": "പുനരാരംഭിക്കുക,",
    "ENABLE_CLOSE": "അടയ്ക്കൽ ഘട്ടം പ്രാപ്തമാക്കാൻ അടയ്ക്കാൻ തുടരുക ബട്ടൺ ക്ലിക്ക് ചെയ്യുക,",
    "LIST_VIEW": "പട്ടിക കാഴ്ച,",
    "TERMINATE": "അവസാനിപ്പിക്കുക,",
    "MINIMIZE": "കുറയ്ക്കുക,",
    "MAXIMIZE": "പരമാവധി പ്രാപ്തമാക്കുക,",
    "NO_SEARCH_RESULT": "തിരച്ചിൽ ഫലം കണ്ടെത്തിയില്ല,",
    "SENTIMENT_AWAITING": "ഭാവം കാത്തിരിക്കുന്നു,",
    "POSITIVE": "ധനാത്മക,",
    "NEGATIVE": "നCAR,",
    "ASSOCIATED_WORK_NOTES": "മുൻ പരിഹാര കുറിപ്പുകൾ,",
    "AGENT_JOINED_CONV": "ഏജന്റ് സംഭാഷണത്തിൽ ചേർന്നു,",
    "AUTOSCROLL_ASSIST": "ഓട്ടോ-സ്ക്രോൾ അസിസ്റ്റ് ടാബ് ഉള്ളടക്കം,",
    "FILE_SIZE_MSG": "ഫയൽ വലുപ്പം 25MB അകത്ത് ആയിരിക്കണം. ദയവായി വീണ്ടും ശ്രമിക്കുക,",
    "OVERRIDE_BTN": "ഓവർറൈഡ്,",
    "CHOOSE_FILE": "ഫയൽ തിരഞ്ഞെടുക്കുക,",
    "SUMMARY_ERROR_TEXT": "ക്ഷമിക്കുക, ഈ സംഭാഷണത്തിന് സാരാംശം സൃഷ്ടിക്കുന്നതിനിടെ ഒരു പ്രശ്നം ഉണ്ടായി. ദയവായി നിങ്ങളുടെ സ്വന്തം സാരാംശം സൃഷ്ടിക്കുക,",
    "ASK_A_QUESTION": "ഒരു ചോദ്യമുന്നയിക്കുക",
    "COPY" : "പകര്‍പ്പ്",
    "PLAYBOOK": "പ്ലേബുക്ക്",
    "TELL_US_MORE": "കൂടുതൽ പറഞ്ഞുതരിക",
    "THANKS_FEEDBACK": "നിങ്ങളുടെ ഫീഡ്ബാക്കിന് നന്ദി",
    "SOMETHING_WRONG": "എന്തെങ്കിലും തെറ്റ് സംഭവിച്ചു",
    "CLICK_ERROR_DETAILS": "തെറ്റ് വിശദാംശങ്ങൾ കാണാൻ ക്ലിക്ക് ചെയ്യുക",
    "NO_ACTIVE_PLAYBOOK": "സജീവമായ പ്ലേബുക്ക് ഇല്ല",
    "REPHRASE_QUESTION": "നിങ്ങളുടെ ചോദ്യം പുനരാഖ്യാനം ചെയ്യാൻ നിങ്ങൾക്ക് കഴിയുമോ, അല്ലെങ്കിൽ മറ്റേതെങ്കിലും ചോദിക്കാമോ?",
    "INTERNAL_INFO": "അന്തര്‍ദേശീയ വിവരങ്ങള്‍",
    "SOURCES": "സ्रोതങ്ങൾ",
    "CONVERSATION_SUMMARY": "സംവാദത്തിന്റെ സാരാംശം",
    "WAITING": "കാത്തിരിക്കുകയാണ്",
    "WIDGET_DISABLED": "വിജറ്റ് അപ്രവർത്തനത്തിലാണ്",
    "AI_SETTINGS_DISABLED": "AI ക്രമീകരണങ്ങൾ അപ്രവർത്തിതമാണ്! ദയവായി AI അഡ്മിനിസ്റ്ററുമായി ബന്ധപ്പെടുക",
    "SERVER_CONNECTION_ERROR": "സെർവറുമായി ബന്ധിപ്പിക്കുമ്പോൾ തെറ്റ്",
    "VIEW": "കാണുക",
    "ATTACHMENT_INPUT": "ആധാര ഫയല്",
    "TYPE_SUMMARY": "സാരാംശം തരംതിരിക്കുക",
    "VIEW_FULL_ARTICLE_2": "പൂർണ്ണ ലേഖനം കാണുക",
    "VIEW_FULL_FILE_2": "പൂർണ്ണ ഫയല് കാണുക",
    "BY":"ദ്വാര",
     GENERATE_SUMMARY: "സംഗ്രഹം സൃഷ്ടിക്കുക",
     PREV_SUMMARIES: "മുമ്പ് സൃഷ്ടിച്ച സംഗ്രഹങ്ങൾ",
    DIALOG_WORKFLOWS: "ഡയലോഗ് വർക്ക്ഫ്ലോകൾ",
    SHOW_ALL_DIALOG: "എല്ലാ ഡയലോഗ് ടാസ്കുകളും കാണിക്കുക",
    SHOW_ALL_DIALOGS: "എല്ലാ ഡയലോഗുകളും കാണിക്കുക",
    CUSTOM_TAB: "കസ്റ്റം ടാബ്",
    AGENT_INPUT: "ഏജന്റ് ഇൻപുട്ട്",
    "CUSTOM_EMPTY_MSG" : "സജീവമായ വർക്ക്ഫ്ലോ ഇല്ല",
    "CUSTOM_TAB_DESC" : "ഒരു വർക്ക്ഫ്ലോ ആരംഭിക്കാൻ, സ്ക്രീൻന്റെ തലത്തിൽ നിന്നുള്ള പട്ടിയിൽ ഒന്ന് ആരംഭിക്കുക.",
    "SUBMIT_OVERALL_FEEDBACK" : "സമഗ്ര ഫീഡ്ബാക്ക് സമർപ്പിക്കുക",
    "FEEDBACK_POPUP_SUBTITLE" : "വിജേറ്റ് മറ്റ് ഫംക്ഷനുകളും മാത്രം",
    "FEEDBACK_SATISFIED" : "സംതോഷപ്പെട്ടത്",
    "FEEDBACK_UNSATISFIED" : "സംതോഷപ്പെട്ടതല്ല",
    "FEEDBACK_PROVIDE_REASONS" : "കൂടുതൽ വിവരങ്ങൾ നൽകുക…",
    "FEEDBACK_TITLE" : "ഫീഡ്ബാക്ക്",
    "AGENTIC_THINKING" : "ചിന്തിക്കുന്നു",
    "AGENTIC_AGENT_TITLE" : "ഏജന്റ്",
    "AGENTIC_COPILOT_MODE_TITLE" : "ഏജന്റിക് കോപൈലറ്റ് മോഡ്",
    "AGENTIC_SENDING_MESSAGE" : "അയയ്ക്കുന്നു...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot നിങ്ങളുടെ സംഭാഷണം സജീവമായി ശ്രവിക്കുകയും സ്വയം സഹായിക്കാൻ തയ്യാറാണ്",
    "AGENTIC_SEARCH_RESULTS" : "ഏജന്റ് ഫലങ്ങൾ",
    "PAUSE_AUTO_SEND" : "സ്വയംചാലിത അയയ്ക്കൽ നിർത്തുക",
    "PAUSE_AGENTIC" : "ഏജന്റ് നിർത്തുക",
    "RESUME_AGENTIC" : "ഏജന്റ് വീണ്ടും ആരംഭിക്കുക",
    "RESUME_AUTO_SEND" : "സ്വയംചാലിത അയയ്ക്കൽ വീണ്ടും ആരംഭിക്കുക"
}